import React, { useEffect, useState } from "react"
import { generatePath, Link, useNavigate } from "react-router-dom"
import { useLocalObservable } from "mobx-react"
import { observer } from "mobx-react-lite"
import { Button, Flex, Input, Table, Tag } from "antd"
import { ColumnsType } from "antd/es/table"
import { SearchOutlined } from "@ant-design/icons"

import { CreateButton } from "@src/app/components/CreateButton"
import { NoContent } from "@src/app/components/NoContent/Index"
import { IdItem } from "@src/app/components/tableRowItems/idItem"
import { paginationConfig } from "@src/app/configs"
import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import { paths } from "@src/app/paths"
import ProjectsCollection from "@src/pages/projects/classes/ProjectsCollection"
import { dateTimeFormat } from "@src/shared/date"
import css from "./index.module.css"

export const ProjectsPage = observer(() => {
  const collection = useLocalObservable(() => new ProjectsCollection())
  const nav = useNavigate()
  const columns: ColumnsType<any> = [
    {
      dataIndex: "id",
      render: (_, { id }) => <IdItem id={id} />,
      title: "ID",
    },
    {
      align: "center",
      dataIndex: "name",
      title: "Name",
    },
    {
      align: "center",
      dataIndex: "description",
      ellipsis: true,
      title: "Description",
    },
    {
      align: "center",
      render: (_, { status }) => (
        <Tag color={status === "active" ? "green" : ""}>{status}</Tag>
      ),
      title: "Status",
    },
    {
      dataIndex: "created_at",
      render: (_, { created_at }) => dateTimeFormat(created_at),
      title: "Created at",
    },
  ]

  const handleRowClick = (record: unknown) => {
    if (record) {
      const { id } = record as { id: string }

      nav(generatePath(paths.projectUpsert, { id: id! }))
    }
  }

  return (
    <>
      <DefaultPageLayout
        button={
          <CreateButton
            className={css.button}
            text="Create a project"
            to={paths.projectUpsert}
          />
        }
        emptyBlock={
          <NoContent
            paragraph="For different business areas, you can create separate Projects by choosing different cryptocurrencies for receiving payments. You will also be able to sort transactions by Projects in the Transactions section."
            title="You haven't created any projects yet."
          />
        }
        hideBack
        isEmpty={collection.isEmpty}
        isLoading={collection.isLoading && collection.isEmpty}
        title="Projects"
      >
        <Flex gap={12} vertical>
          <Flex>
            <Input.Search
              enterButton
              onSearch={(e) => (collection.search = e)}
              placeholder={"Search by ID"}
              style={{ width: 300 }}
            ></Input.Search>
          </Flex>
          <Table
            columns={columns}
            dataSource={collection.searchedValue}
            loading={collection.isLoading}
            onRow={(record) => ({
              onClick: () => handleRowClick(record), // Set the row click handler
            })}
            pagination={collection.pagination}
            rowClassName={css.row}
          />
        </Flex>
      </DefaultPageLayout>
    </>
  )
})
